import $ from "jquery";
import React, { Suspense, useContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import UserBasicInfoContext from '../../../components/Context/UserBasicInfoContext';
import UserBasicInfoQRContext from '../../../components/Context/UserBasicInfoQRContext';
import AllVoucher from './AllVoucher/AllVoucher';
import Brand from './Brand/Brand';
import Offer from './Offer/Offer';
import RequestedOffer from './Offer/RequestedOffer';

const Voucher = () => {
    const [currentTab, setCurrentTab] = useState("AllVoucher");
    const userProfile = useContext(UserBasicInfoContext);

    const companyInfo = useContext(UserBasicInfoQRContext);

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }


    const { state } = useLocation();

    useEffect(() => {

        let index = 0;
        
        if ((index >= 0) &&
            (state?.tab !== null && state?.tab !== undefined && state?.tab !== "")) {
            if (state?.tab === "category") {
                $(".tablinks").eq(index).trigger("click");
            }
            if (state?.tab === "brand") {
                $(".tablinks").eq(index + 1).trigger("click");
            }
            if (state?.tab === "offer") {
                $(".tablinks").eq(index + 2).trigger("click");
            }
            if (state?.tab === "requested-offer") {
                $(".tablinks").eq(index + 3).trigger("click");
            }
        }

    }, [state, userProfile]);

    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20 ">

            {(companyInfo?.id === null || companyInfo?.id === "" || companyInfo?.id === undefined) ?
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Before proceeding, please select a company.
                            </td>
                        </tr>
                    </tbody>
                </table>
                :
                <>
                    {/* TAB SWITCHER */}
                    <div className="tab w-full">

                        <button className="tablinks current" onClick={(event) => handleTab("AllVoucher", event)}>Vouchers</button>
                        <button className="tablinks" onClick={(event) => handleTab("brand", event)}>Brand</button>
                        <button className="tablinks" onClick={(event) => handleTab("offer", event)}>Offer</button>
                        <button className="tablinks" onClick={(event) => handleTab("requested-offer", event)}>Requested Offer</button>
                    </div>

                    <div className='tabcontentbody py-3 px-0'>
                        <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px", paddingRight: "0px" }}>
                            <Suspense fallback="Loading...">

                                {(() => {
                                    switch (currentTab) {
                                        case "AllVoucher":
                                            return <AllVoucher />;
                                        case "brand":
                                            return <Brand />;
                                        case "offer":
                                            return <Offer />;
                                        case "requested-offer":
                                            return <RequestedOffer />;
                                        default:
                                            return <>No page found</>;
                                    }
                                })()}

                            </Suspense>
                        </div>
                    </div>

                </>
            }



            <style>{`
                .custom-scroll-auto { 
                    overflow-x: hidden;
                }

                .tab button:hover::after, .tab button.current::after { 
                    width: 120% !important;
                    margin-left: -10% !important;
                }
                `}</style>


        </div>
    );
};

export default Voucher;